import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function PaymentGate({ children, brand }) {
  if (brand?.payment_on_file) return children;
  return (
    <div className="text-center py-12 bg-[#111827] border border-[#FF4343]/30 p-6" data-testid="payment-gate">
      <AlertTriangle className="w-10 h-10 text-[#FF4343] mx-auto mb-3" />
      <h3 className="font-display text-lg font-bold mb-2">Payment Method Required</h3>
      <p className="text-sm text-[#9CA3AF] mb-4">Add a credit card in the <strong>Settings</strong> tab before you can search executives, send offers, or fund campaigns.</p>
    </div>
  );
}
